import React, { Component } from 'react';
import ReactLoading from 'react-loading';
import swal from 'sweetalert';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import EmployeeContainer from '../../Employee';
import MaintenanceTechnicalReportForm from './form';
import MaintenanceTechnicalList from './list';
import API from '../../../services/api';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

// Styles
import { SubContainer } from '../../../css/styles/wrapper';
import maintenanceEmployeeList from '../MaintenanceEmployee/list';
import { Description } from '@material-ui/icons';

class MaintenanceTechnicalReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      maintenanceTechnicalReport: null,
      employeeForm: false,
      employee: null,
      employees: [],
      technicalReports: [],
    };

    this.handleCreation = this.handleCreation.bind(this);
  }

  refMaintenanceTechnicalReport = React.createRef();

  scrollToMyRef = myRef => {
    window.scrollTo(0, myRef.current.offsetTop);
  };

  handleCreation = async object => {
    const {
      maintenance,
      onMaintenanceTechnicalReportSubmit,
      onMaintenanceTechnicalReportList,
      onMaintenanceTechnicalReportEdit,
    } = this.props;

    if (!object?.technicalReport?.uuid) {
      return;
    }

    const data = {
      maintenanceUuid: maintenance.uuid,
      technicalreportUuid: object.technicalReport.uuid,
    };

    try {
      const response = await API.post('/maintenancetechnicalreports', {
        ...data,
      });
      onMaintenanceTechnicalReportList(response.data.maintenanceUuid);
      this.handleTechnicalReportsOptions();
      toast.success('Relatório Técnico alocado com sucesso!');
      onMaintenanceTechnicalReportSubmit();
    } catch (err) {
      toast.error('Um erro aconteceu durante o cadastro do relatório técnico!');
    }
  };

  handleTechnicalReportsOptions = async () => {
    this.setState({ loading: true });
    try {
      const response = await API.get('/technicalreports/options');
      this.setState({ technicalReports: response.data, loading: false });
    } catch (error) {
      this.setState({ loading: false });
      console.error('Erro ao listar technical reports', error);
    }
  };

  handleGetList = async value => {
    const { maintenance, onMaintenanceTechnicalReportList } = this.props;

    this.setState({
      loading: true,
    });
    try {
      const response = onMaintenanceTechnicalReportList(maintenance.uuid);
      this.setState({
        maintenanceTechnicalReports: response.data,
        loading: false,
      });
    } catch (err) {
      toast.error('Um erro aconteceu durante o carregamento da lista!');
      console.error(err, 'erro ao carregar! teste');
      this.setState({ loading: false });
    }
  };

  async componentDidMount() {
    await this.handleTechnicalReportsOptions();
    await this.handleGetList();
  }

  handleEdit = object => {
    this.setState({
      maintenanceTechnicalReport: object,
    });
  };

  handleNew = () => {
    this.setState({ maintenanceTechnicalReport: null, employee: null });
  };

  handleUpdate = async values => {
    const {
      onMaintenanceTechnicalReportSubmit,
      onMaintenanceTechnicalReportList,
      onMaintenanceTechnicalReportEdit,
    } = this.props;

    const { maintenanceTechnicalReport } = this.state;
    const data = {
      technicalreportUuid: values.technicalReport.uuid,
    };
    try {
      await API.put(
        `/maintenancetechnicalreports/${maintenanceTechnicalReport.uuid}`,
        data
      );

      await onMaintenanceTechnicalReportList(
        maintenanceTechnicalReport.maintenanceUuid
      );
      await onMaintenanceTechnicalReportEdit({
        uuid: this.state.maintenanceTechnicalReport.maintenanceUuid,
      });
      this.handleNew();
      toast.success('Relatório Técnico atualizado com sucesso.');
      onMaintenanceTechnicalReportSubmit();
    } catch (error) {
      toast.error('Um erro aconteceu durante a atualização!');
    }
  };

  handleDelete = async object => {
    this.handleEdit(object);
    const {
      onMaintenanceTechnicalReportSubmit,
      onMaintenanceTechnicalReportList,
      onMaintenanceTechnicalReportEdit,
    } = this.props;

    try {
      const confirmDelete = await swal({
        dangerMode: true,

        text: 'Confirma a exclusão do Relatório Técnico?',

        buttons: {
          cancel: 'Não',

          confirm: 'Sim',
        },
      });

      if (confirmDelete) {
        await API.delete(`maintenancetechnicalreports/${object.uuid}`);
        await onMaintenanceTechnicalReportList(
          this.state.maintenanceTechnicalReport.maintenanceUuid
        );
        await onMaintenanceTechnicalReportEdit({
          uuid: this.state.maintenanceTechnicalReport.maintenanceUuid,
        });
        this.handleNew();
        toast.success('Relatório Técnico deletado com sucesso!');
        onMaintenanceTechnicalReportSubmit();
      }
    } catch (err) {
      toast.error('Um erro aconteceu durante a exclusão!');
    }
  };

  handleMaintenanceTechnicalReportFormState() {
    const { employeeForm } = this.state;

    this.setState({
      employeeForm: !employeeForm,
    });
  }

  render() {
    const {
      maintenanceTechnicalReportForm,
      maintenanceTechnicalReports,
    } = this.props;
    const { maintenanceTechnicalReport, loading } = this.state;
    return (
      <SubContainer visible={maintenanceTechnicalReportForm}>
        <div ref={this.refMaintenanceTechnicalReport} />

        <nav>
          <h1>RELATÓRIOS TÉCNICOS</h1>

          <button type="button">
            <Link
              to="technicalReports"
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              CRIAR RELATÓRIO
            </Link>
          </button>
        </nav>

        {loading ? (
          <ReactLoading type="spin" color="#011826" height={40} width={40} />
        ) : (
          <MaintenanceTechnicalList
            maintenanceTechnicalReports={maintenanceTechnicalReports}
            onEdit={this.handleEdit}
            onDelete={this.handleDelete}
          />
        )}

        <MaintenanceTechnicalReportForm
          onUpdate={this.handleUpdate}
          onNew={this.handleNew}
          onCreation={this.handleCreation}
          maintenanceTechnicalReport={maintenanceTechnicalReport}
          technicalReports={this.state.technicalReports}
        />
      </SubContainer>
    );
  }
}

MaintenanceTechnicalReport.propTypes = {
  maintenance: PropTypes.shape({
    uuid: PropTypes.string,
  }).isRequired,
  maintenanceTechnicalReports: PropTypes.arrayOf(),
  onMaintenanceTechnicalReportsList: PropTypes.func.isRequired,
  onMaintenanceTechnicalReportSubmit: PropTypes.func.isRequired,
  maintenanceTechnicalReportForm: PropTypes.bool.isRequired,
};

export default MaintenanceTechnicalReport;
